import { MealyModelType } from '../mealyModelType';
import Kunstautomat from './Kunstautomat.svelte';
export const mealyModelKunstautomat1 = {
    component: Kunstautomat,
    type: MealyModelType.KUNSTAUTOMAT2,
    alphabet: ['1€', 'Ware', 'Geld'],
    outputs: ['Ware', '1€', '2€', 'nichts'],
};
export const mealyModelKunstautomat2 = {
    component: Kunstautomat,
    type: MealyModelType.KUNSTAUTOMAT1,
    alphabet: ['1€', '2€', 'Ware', 'Geld'],
    outputs: ['Ware', '1€', '2€', '3€', 'nichts'],
};
